export const LEGAL_NAME = "Servicios Digitales TR, S.A. de C.V., SOFOM, E.N.R.";

export const safeName = (s) => String(s).replace(/[\\/:*?"<>|]+/g, "-").trim();

export const notifyBandejaChanged = (count) => window.dispatchEvent(new CustomEvent("bandeja:changed", { detail: { count } }));
